export default "__VITE_ASSET__Ccv_qsyu__"